/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBranchServiceCreateInput } from "../../entities/models/BranchServiceCreateInput";
import { z } from "zod/v4";

export const modelsBranchServiceCreateInputSchema = z.object({
    "discount_type": z.optional(z.enum(["percentage", "fixed"])),
"discount_value": z.optional(z.number()),
"duration_minutes": z.optional(z.int()),
"price": z.optional(z.number()),
"service_id": z.int()
    }) as unknown as z.ZodType<ModelsBranchServiceCreateInput>